const pendingEditFlushes = new Set<() => void>();

export function registerPendingEdit(flush: () => void): () => void {
    pendingEditFlushes.add(flush);
    return () => {
        pendingEditFlushes.delete(flush);
    };
}

export function flushPendingRichTextEdits(): void {
    pendingEditFlushes.forEach((flush) => flush());
}
